import { render } from "./AddFacturePage.vue?vue&type=template&id=64895272&ts=true"
import script from "./AddFacturePage.vue?vue&type=script&lang=ts"
export * from "./AddFacturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__